module.exports = __webpack_public_path__ + "media/images/application/template/logos/logo-group-f58f52bbfc87f7756973200cbcbba2ec.svg";